import script from "./PopupAppointment.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupAppointment.vue?vue&type=script&lang=ts&setup=true"

import "./PopupAppointment.vue?vue&type=style&index=0&id=7b8fb8ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8fb8ef"]])

export default __exports__